import type { AlgoliaProductCard, ProductCard as ProductCardType } from "@raumagarn/formatters";
import { ProductCard } from "~/features/products/ProductCard/ProductCard";
import { ProductGrid } from "~/features/products/ProductGrid";

export const ProductSection = ({
	products,
	onProductClick,
}: {
	products: (ProductCardType | AlgoliaProductCard)[];
	onProductClick?: (product: ProductCardType | AlgoliaProductCard) => void;
}) => {
	return (
		<ProductGrid>
			{products?.map((product, i) => (
				<ProductCard
					productCard={product}
					key={i}
					onClick={onProductClick ? () => onProductClick(product) : undefined}
				/>
			))}
		</ProductGrid>
	);
};
